import React from 'react'
import "./Spinner.css"

const Spinner = () => {
  return (
    <div className='spinner my-10'>
      
    </div>
  )
}

export default Spinner
